import { FormControl } from "@mui/material";
import { useContext } from "react";
import { expenditureOptions } from "../../consts/inputs";
import { FootprintContext } from "../../pages/profile_pages/EditLifestylePage";
import InputField from "../inputs/InputField";
import InputLabel from "../inputs/InputLabel";

export default function Step1Inputs() {
    const [expenditureInput, setExp] = useContext(FootprintContext).expenditureInput;

    return(
        <FormControl>
            <InputLabel label={<>Monthly <b>Individual</b> Spending</>} />
            <InputField 
                value={expenditureInput}
                setValue={setExp} 
                options={expenditureOptions}
                startAdornment={'$'}
                isNumeric={true}
                isCustomisable={false}
            />
        </FormControl>
    )
}

